import { PaymentMethodPriority } from "../enums";
import { IAPIPaymentMethodModel, IAPIPaymentMethodReferenceInPurchases } from "../interfaces";
import { PaymentMethodModel } from "./PaymentMethodModels";

export class RelatedPaymentMethodGridModel {
    id: string;
    status: string;
    paymentMethod: PaymentMethodModel;
    expirationDate: string;
    activity: string;
    isPrimary: boolean;
    priority: keyof typeof PaymentMethodPriority;
    constructor(data: Partial<RelatedPaymentMethodGridModel>) {
        this.id = data.id || '';
        this.status = data?.status || '';
        this.paymentMethod = data?.paymentMethod || new PaymentMethodModel();
        this.expirationDate = data?.expirationDate || '';
        this.activity = data?.activity || '';
        this.priority = data?.priority || 'Primary';
        this.isPrimary = data?.priority === 'Primary';
    }

    static deserializeAPIModel(data: IAPIPaymentMethodModel): RelatedPaymentMethodGridModel {
        const mappedData: Partial<RelatedPaymentMethodGridModel> = {
            id: data.id,
            status: 'Active',
            paymentMethod: PaymentMethodModel.deserializeAPIModel(data),
            expirationDate: data.card ? `${data.card.expiryMonth}/${data.card.expiryYear}` : '',
            activity: '',
            isPrimary: data.isDefault,
            priority: data.priority,
        };
        return new RelatedPaymentMethodGridModel(mappedData);
    }
}

export class PaymentMethodReferenceInPurchases {
    paymentMethod: PaymentMethodModel;
    subscriptions: number;
    scheduledInvoices: number;
    totalPaidAmount: number;
    lastUsed?: Date;
    totalPaymentMethods: number;
    constructor(data?: Partial<PaymentMethodReferenceInPurchases>) {
        this.subscriptions = data?.subscriptions || 0;
        this.scheduledInvoices = data?.scheduledInvoices || 0;
        this.totalPaidAmount = data?.totalPaidAmount || 0;
        this.lastUsed = data?.lastUsed;
        this.totalPaymentMethods = data?.totalPaymentMethods || 0;
        this.paymentMethod = data?.paymentMethod || new PaymentMethodModel();
    }

    static deserializeAPIModel(data: IAPIPaymentMethodReferenceInPurchases): PaymentMethodReferenceInPurchases {
        const mappedData: Partial<PaymentMethodReferenceInPurchases> = {
            paymentMethod: PaymentMethodModel.deserializeAPIModel(data.paymentMethod),
            subscriptions: data.subscriptions,
            scheduledInvoices: data.scheduledInvoices,
            totalPaidAmount: data.totalPaidAmount,
            lastUsed: data.lastUsed ? new Date(data.lastUsed) : undefined,
            totalPaymentMethods: data.totalPaymentMethods,
        };
        return new PaymentMethodReferenceInPurchases(mappedData);
    }
}
